import React, { useRef, useEffect, useCallback } from 'react'
import { HugeRTEWrapper } from '@veritas/huge-rte-wrapper'

export const Editor = React.forwardRef((props, ref) => {
    const { disabled, ...otherProps } = props;
    const editorInstanceRef = useRef(null);
    
    useEffect(() => {
        if (editorInstanceRef.current) {
            try {
                const body = editorInstanceRef.current.getBody?.();
                if (body) {
                    body.style.backgroundColor = disabled ? 'rgba(220, 220, 220, 0.5)' : 'white';
                }
            } catch (error) {
                console.warn('Error updating editor background:', error);
            }
        }
    }, [disabled]);

    const handleInit = useCallback((evt, editor) => {
        editorInstanceRef.current = editor;
        if (ref) {
            if (typeof ref === 'function') {
                ref(editor);
            } else {
                ref.current = editor;
            }
        }
        // Set initial background color
        try {
            const body = editor.getBody?.();
            if (body) {
                body.style.backgroundColor = disabled ? 'rgba(220, 220, 220, 0.5)' : 'white';
            }
        } catch (error) {
            console.warn('Error setting initial editor background:', error);
        }
    }, [ref, disabled]);

    return (
        <HugeRTEWrapper
            {...otherProps}
            disabled={disabled}
            onInit={handleInit}
            init={{
                selector: 'textarea',
                content_style: `
                    body {
                        background-color: white;
                        font-size: 13px;
                    }
                    .mention-tag-editor {
                        font-weight: bold !important;
                        background-color: rgba(120, 213, 126, 0.15) !important;
                        padding: 2px 6px !important;
                        border-radius: 4px !important;
                        display: inline-block !important;
                    }
                `,
            }}
        />
    )
});